
export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/index'),
        meta:{
            title:'登陆',
            keep:true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/login/register'),
        meta:{
            title:'注册',
            keep:true
        }
    }
]
